/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  CurrencyValueModel,
  DeliveryServiceVoModel,
  OptionalUiIdentifiableModel,
  ShipmentCommonsAttachmentDTO,
  ShipmentCommonsCmrDTO,
  ShipmentStatusChangeDtoModel
} from '@well/domain';
import { CostCenterResourceItemVO } from '@well/delivery-libs/cost-center/domain';
import { HandoverDtoModel } from '@well/delivery-libs/handover/domain';
import { Maybe } from '@irian-ro/util-functions';
import { PackageDtoModel } from '@well/delivery-libs/packages/domain';
import {
  ContractTariffItemVoModel,
  PackageContractTariffItemVoModel
} from '@well/delivery-libs/contract-management/shell-domain';
import { ShipmentVehicleDtoModel } from './shipment-vehicle-dto.model';
import { ShipmentDriverDtoModel } from './shipment-driver-dto.model';
import { ShipmentState } from './shipment-state';
import { ShipmentAttachmentDTO } from './shipment-attachment-dto.model';
import { ShipmentCmrDTO } from './shipment-cmr-dto.model';
import { DelEmployeeVoModel } from '@well/delivery-libs/employee/domain';
import { ProductCustomsClearanceDtoModel } from '@well/product-customs-clearance/domain';

export class ShipmentDtoModel extends OptionalUiIdentifiableModel {
  uuid: string | null = '';
  owner: string | null = '';
  shipmentFlowType: string | null = null;
  externalReference: string | null = '';
  transportProjectUuid: string | null = '';
  dispatcherUuid: string | null = '';
  offerUuid: string | null = '';
  deleted: boolean | null = null;

  orderUuid: string | null = null;

  spOfferRequestUuid: Maybe<string> | undefined = undefined;

  packages: PackageDtoModel[]  = [];

  productCustomsClearanceDTOS: ProductCustomsClearanceDtoModel[] = [];

  pickup: HandoverDtoModel | null | undefined = undefined;

  delivery: HandoverDtoModel | null | undefined = undefined;

  budget:  Maybe<number> | undefined = undefined;

  type: Maybe<string> | undefined = undefined;

  cargoValue: Maybe<number> | undefined = undefined;

  locked:  Maybe<boolean> | undefined = undefined;

  stackable:  Maybe<boolean> | undefined = undefined;

  tags: string[] = [];

  version: Maybe<number> | undefined = undefined;

  assignedDispatcher: Maybe<DelEmployeeVoModel> | undefined = undefined;

  deliveryService: Maybe<DeliveryServiceVoModel> | undefined = undefined;

  price: Maybe<CurrencyValueModel> | undefined = undefined;

  budgetCurrencyValue: Maybe<CurrencyValueModel> | undefined = undefined;

  cargoCurrencyValue: Maybe<CurrencyValueModel> | undefined = undefined;

  tariffUuid: Maybe<string> | undefined = undefined;

  customsDuty: Maybe<boolean> | undefined = undefined;

  customsRegime:  Maybe<boolean> | undefined = undefined;

  awb: Maybe<string> | undefined = undefined;

  pinned:  Maybe<boolean> | undefined = undefined;

  shipmentBaseUuid: Maybe<string> | undefined = undefined;

  shipmentCommonsUuid: Maybe<string> | undefined = undefined;

  basedOnShipmentRequestUuid: Maybe<string> | undefined = undefined;

  completeShipmentBaseUuid: Maybe<string> | undefined = undefined;

  shipmentVendorTemplateUuid: Maybe<string> | undefined = undefined;

  scheduledShipmentUuid: Maybe<string> | undefined = undefined;

  cmrFiles: Maybe<ShipmentCmrDTO[]> = null;

  attachments: Maybe<ShipmentAttachmentDTO[]> = null;

  shipmentStatusChangeDTO: Maybe<ShipmentStatusChangeDtoModel> | undefined = undefined;

  costCenter: Maybe<CostCenterResourceItemVO> | undefined = undefined;

  contractTariffItemVO: ContractTariffItemVoModel | null = null;
  packageContractTariffItemVOs: PackageContractTariffItemVoModel[] = [];

  plannerUuid: string | null = null;

  shipmentVehicleDTO: ShipmentVehicleDtoModel | null = null;
  shipmentDriverDTO: ShipmentDriverDtoModel | null = null;

  series: string | null = null;

  state: ShipmentState | null = new ShipmentState();

  constructor() {
    super();
    this.pickup = new HandoverDtoModel();
    this.delivery = new HandoverDtoModel();
    this.packages = [];
  }
}
